import { useContext } from 'react';
import type { FunctionComponent } from 'react';

import type { ForwardProps } from '../../types';
import Flex from '../Flex';

import MenuContext from './Menu.context';
import { StyledMenuGroupHeader } from './Menu.styles';
import type { MenuGroupProps } from './Menu.types';
import MenuItem from './MenuItem';

const MenuGroup: FunctionComponent<MenuGroupProps & ForwardProps> = ({
  id,
  label,
  items,
  itemRole
}: MenuGroupProps) => {
  const { componentId } = useContext(MenuContext);

  const groupId = `${componentId}-${id}`;
  return (
    <li role='presentation'>
      <Flex
        container={{ alignItems: 'center', pad: [0.5, 1] }}
        as={StyledMenuGroupHeader}
        id={groupId}
      >
        {label}
      </Flex>
      <ul role='group' aria-labelledby={groupId}>
        {items.length > 0 &&
          items.map(item => {
            return <MenuItem {...item} key={item.id} role={itemRole ?? 'menuitem'} />;
          })}
      </ul>
    </li>
  );
};

export default MenuGroup;
